export default __webpack_public_path__ + "static/media/ecesultan2.c837d281.jpg";